import { NavLink, useLoaderData } from "@remix-run/react";
import { NavIconProps } from "~/utils/interfaces/components";

const ContactsIcon = (props: NavIconProps) => {
  const {
    width = 24,
    height = 24,
    color = "#BCBCBC",
    color2 = "#3fff6f",
    label = "",
    selected = false,
    name = "home",
  } = props;

  return (
    <NavLink
      to={name}
      aria-label="Contacts"
      className={({ isActive, isPending }) => {
        return `nav-item-container ${
          isActive ? "active" : isPending ? "pending" : ""
        }`;
      }}
    >
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.4802 2.81994L19.7602 3.38993C19.9002 3.66993 20.2502 3.92994 20.5602 3.98994L20.9402 4.04994C22.0802 4.23994 22.3502 5.07994 21.5302 5.90994L21.1802 6.25993C20.9502 6.49993 20.8202 6.95993 20.8902 7.27993L20.9402 7.48994C21.2502 8.86994 20.5202 9.39993 19.3202 8.67993L19.0602 8.52993C18.7502 8.34993 18.2502 8.34993 17.9402 8.52993L17.6802 8.67993C16.4702 9.40993 15.7402 8.86994 16.0602 7.48994L16.1102 7.27993C16.1802 6.95993 16.0502 6.49993 15.8202 6.25993L15.4702 5.90994C14.6502 5.07994 14.9202 4.23994 16.0602 4.04994L16.4402 3.98994C16.7402 3.93994 17.1002 3.66993 17.2402 3.38993L17.5202 2.81994C18.0602 1.72994 18.9402 1.72994 19.4802 2.81994Z"
          fill={color}
          className="svg-path"
        />
        <path
          opacity="0.4"
          d="M22 9.67V15.5C22 19 20 20.5 17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H14.05C13.85 3.72 13.7 3.98 13.61 4.27C13.32 5.17 13.61 6.15001 14.41 6.96001L14.6 7.14999C14.19 8.95999 15.04 9.81 15.43 10.09C15.65 10.25 16.1 10.5 16.74 10.5C17.21 10.5 17.79 10.36 18.46 9.96001L18.5 9.94L18.54 9.96001C20.12 10.91 21.19 10.37 21.57 10.09C21.69 10.01 21.85 9.87 22 9.67Z"
          fill={color}
          className="svg-path"
        />
        <path
          d="M11.9998 12.8698C11.1598 12.8698 10.3098 12.6098 9.65978 12.0798L6.52978 9.57978C6.20978 9.31978 6.14978 8.84978 6.40978 8.52978C6.66978 8.20978 7.13977 8.14978 7.45977 8.40978L10.5898 10.9098C11.3498 11.5198 12.6398 11.5198 13.3998 10.9098C13.7198 10.6498 14.1898 10.6998 14.4498 11.0298C14.7098 11.3498 14.6598 11.8298 14.3298 12.0798C13.6898 12.6098 12.8398 12.8698 11.9998 12.8698Z"
          fill={color}
          className="svg-path"
        />
      </svg>
      <p className="nav-label">{label}</p>
    </NavLink>
  );
};

export default ContactsIcon;
